import React, { useState, useCallback } from 'react';
import { Button, Space } from 'antd';
import { useQuery } from '@tanstack/react-query';
import MemberTypeTable from './components/MemberTypeTable';
import MemberTypeDrawer from './components/MemberTypeDrawer';
import { getMemberTypeList } from './api';
import { MemberTypeSearchParams, MemberTypeRecord } from './types';
import { QUERY_KEYS } from './constants';

const DEFAULT_PAGE_SIZE = 10;

const MemberTypePage: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingMemberType, setEditingMemberType] = useState<MemberTypeRecord | null>(null);

  const { data, isLoading, refetch } = useQuery({
    queryKey: [QUERY_KEYS.MEMBER_TYPE_LIST, currentPage, pageSize],
    queryFn: async () => {
      return getMemberTypeList({
        currentPage,
        pageSize,
      });
    },
  });

  const handleTableChange = useCallback((page: number, size?: number) => {
    setCurrentPage(page);
    if (size && size !== pageSize) {
      setPageSize(size);
      setCurrentPage(1); // 切换每页条数时重置到第一页
    }
  }, [pageSize]);

  const openDrawer = useCallback((memberType: MemberTypeRecord | null = null) => {
    setEditingMemberType(memberType);
    setDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setDrawerOpen(false);
    setEditingMemberType(null);
  }, []);

  const handleDrawerSuccess = useCallback(() => {
    refetch();
  }, [refetch]);

  return (
    <div>
      <Space style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between' }}>
        <Button type="primary" onClick={() => openDrawer(null)}>
          新增
        </Button>
      </Space>

      <MemberTypeTable
        data={data?.records || []}
        loading={isLoading}
        pagination={{
          current: currentPage,
          pageSize,
          total: data?.total || 0,
          onChange: handleTableChange,
        }}
        onEdit={openDrawer}
      />

      <MemberTypeDrawer
        open={drawerOpen}
        editingMemberType={editingMemberType}
        onClose={closeDrawer}
        onSuccess={handleDrawerSuccess}
      />
    </div>
  );
};

export default MemberTypePage;

